// extracted by mini-css-extract-plugin
export default {"service_card":"service-card_service_card__CgycW","title":"service-card_title__p4upj","subtitle":"service-card_subtitle__jSYdq","text":"service-card_text__IRPbc"};